import useTrendLocationDelivery, {
  trendLocationDeliveryConfigs,
} from './useTrendLocationDelivery'
import useTrendLocationGroupDelivery, {
  trendLocationGroupDeliveryConfigs,
} from './useTrendLocationGroupDelivery'

export const configs = {
  trendLocationGroupDelivery: trendLocationGroupDeliveryConfigs,
  trendLocationDelivery: trendLocationDeliveryConfigs,
}

export const api = {
  trendLocationGroupDelivery: useTrendLocationGroupDelivery,
  trendLocationDelivery: useTrendLocationDelivery,
}
